export const EDIT_PROFILE = "EDIT_PROFILE";
export const PROFILE_SUCCESS = "PROFILE_SUCCESS";
export const PROFILE_ERROR = "PROFILE_ERROR";
export const RESET_PROFILE_STATUS = "RESET_PROFILE_STATUS";
export const RECEIVED_PROFILE = "RECEIVED_PROFILE";
export const FETCH_PROFILE = "FETCH_PROFILE";
export const UPDATE_PROFILE_SWITCH = "UPDATE_PROFILE_SWITCH";
export const UPDATE_PROFILE = "UPDATE_PROFILE";
export const UPDATE_PROFILE_SUCCESS = "UPDATE_PROFILE_SUCCESS";
export const UPDATE_PROFILE_ERROR = "UPDATE_PROFILE_ERROR";
export const RESET_UPDATE_PROFILE_STATUS = "RESET_UPDATE_PROFILE_STATUS";
